import React from 'react'

import { DialogContentText as MuiDialogContentText, DialogContentTextProps } from '@material-ui/core'

const DialogContentText: React.FC<DialogContentTextProps> = ({ children, ...rest }) => (
  <MuiDialogContentText {...rest}>{children}</MuiDialogContentText>
)

export default DialogContentText
